import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=adec5232&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adec5232')) {
      api.createRecord('adec5232', component.options)
    } else {
      api.reload('adec5232', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=adec5232&", function () {
      api.rerender('adec5232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8pczabUw76aU2/JS/comp/openstreetmap.vue"
export default component.exports